function headerAnimationInit(sectionSelector) {
  const $container = $(sectionSelector);
  $container
    .find(`.voiceradar-section-header .title`)
    .addClass("animate__fadeInUp animate__animated");
  $container
    .find(`.voiceradar-section-header .subtitle`)
    .addClass("animate__fadeInUp animate__animated");
}

const notifyModule = {
  selector: ".voiceradar-notify",
  $container: null,

  init() {
    this.$container = $(this.selector);
    gsap.timeline({
      scrollTrigger: {
        trigger: this.selector + " .title-desc-content",
        start: `top 60%`,
        toggleClass: "active",
      },
    });
  },
};

const productModule = {
  selector: ".voiceradar-product",
  $container: null,

  init() {
    this.$container = $(this.selector);

    gsap.timeline({
      scrollTrigger: {
        trigger: this.selector + " .title-desc-content",
        start: `top 60%`,
        toggleClass: "active",
      },
    });
  },
};
const bannerModule = {
  selector: ".voiceradar-banner",
  $container: null,
  init() {
    this.$container = $(this.selector);
    const isMobile = window.innerWidth < 769;
    const headerHeight = isMobile
      ? 0
      : $("#shopify-section-header-classic").height() +
        $("#shopify-section-header__icon-bar").height();

    ScrollTrigger.defaults({
      scrub: true,
    });

    gsap.to(".first .logo", { y: 0, opacity: 1, duration: 0.5 });
    gsap.to(".first .slogan", {
      y: 0,
      opacity: 1,
      duration: 0.5,
      delay: 0.3,
    });

    gsap.registerPlugin(ScrollTrigger);
    gsap
      .timeline({
        scrollTrigger: {
          trigger: this.selector,
          start: `top ${headerHeight}`,
          end: `+=${this.$container.height()}`,
          pin: true,
        },
      })
      .to(this.selector + " .mask", { opacity: 0.3 }, "hide")
      .to(this.selector + " .first", { opacity: 0, y: "-20%" }, "hide")
      .to(this.selector + " .bg", { opacity: 0, y: 0 }, "hide")
      .to(this.selector + " .bg2", { opacity: 1, y: 0 }, "secondShow")
      .to(
        this.selector + " .second .slogan .slogan-img",
        { opacity: 1, y: 0 },
        "secondShow"
      )
      .to(
        this.selector + " .second .slogan .slogan-title",
        { opacity: 1, y: 0, delay: 0.2 },
        "secondShow"
      )
      .to(
        this.selector + " .second .slogan .slogan-desc",
        { opacity: 1, y: 0, delay: 0.2 },
        "secondShow"
      )
      .to(
        this.selector + " .second .slogan .slogan-auth",
        { opacity: 1, y: 0, delay: 0.4 },
        "secondShow"
      );
  },
};

const bannerModule1 = {
  selector: ".voiceradar-banner-first",
  $container: null,
  init() {
    const isMobile = window.innerWidth < 769;
    this.$container = $(this.selector);

    const headerHeight = isMobile
      ? 0
      : $("#shopify-section-header-classic").height() +
        $("#shopify-section-header__icon-bar").height();
    // if (isMobile) {
    gsap.timeline({
      scrollTrigger: {
        trigger: this.selector + " .title-desc-content",
        start: `top 60%`,
        toggleClass: "active",
      },
    });
    // } else {
    //   gsap
    //     .timeline({
    //       scrollTrigger: {
    //         trigger: this.selector,
    //         start: `top ${headerHeight}`,
    //         pin: true,
    //       },
    //     })
    //     .to(this.selector + " .mask", { opacity: 0.5 })
    //     .to(this.selector + " .text-container", {
    //       opacity: 1,
    //       y: 0,
    //     });
    // }
  },
};
const bannerModule2 = {
  selector: ".voiceradar-banner-second",
  $container: null,
  init() {
    this.$container = $(this.selector);
    const isMobile = window.innerWidth < 769;
    const headerHeight = isMobile
      ? 0
      : $("#shopify-section-header-classic").height() +
        $("#shopify-section-header__icon-bar").height();

    ScrollTrigger.defaults({
      scrub: true,
    });

    gsap.registerPlugin(ScrollTrigger);
    gsap
      .timeline({
        scrollTrigger: {
          trigger: this.selector,
          start: `top ${headerHeight}`,
          end: `+=${this.$container.height()}`,
          pin: true,
        },
      })
      // .to(this.selector + " .mask", { opacity: 0.3 }, "hide")
      // .to(this.selector + " .first", { opacity: 0, y: "-20%" }, "hide")
      // .to(this.selector + " .bg", { opacity: 0, y: 0 }, "hide")
      // .to(this.selector + " .bg2", { opacity: 1, y: 0 }, "secondShow")
      .to(
        this.selector + " .slogan .slogan-img",
        { opacity: 1, y: 0 },
        "secondShow"
      )
      .to(
        this.selector + " .slogan .slogan-title",
        { opacity: 1, y: 0, delay: 0.2 },
        "secondShow"
      )
      .to(
        this.selector + " .slogan .slogan-desc",
        { opacity: 1, y: 0, delay: 0.2 },
        "secondShow"
      )
      .to(
        this.selector + " .slogan .slogan-auth",
        { opacity: 1, y: 0, delay: 0.4 },
        "secondShow"
      );
  },
};

const noiseCancellactionModule = {
  selector: ".voiceradar-noise-cancellation",
  $container: null,
  init() {
    this.$container = $(this.selector);

    gsap.timeline({
      scrollTrigger: {
        trigger:
          this.selector +
          " .video-item:nth-child(1) .voiceradar-section-header",
        start: `top 90%`,
        end: "+=300%",
        toggleClass: "active",
      },
    });
    gsap.timeline({
      scrollTrigger: {
        trigger:
          this.selector +
          " .video-item:nth-child(2) .voiceradar-section-header",
        start: `top 90%`,
        end: "+=300%",
        toggleClass: "active",
      },
    });
    gsap.timeline({
      scrollTrigger: {
        trigger:
          this.selector +
          " .video-item:nth-child(3) .voiceradar-section-header",
        start: `top 90%`,
        end: "+=300%",
        toggleClass: "active",
      },
    });
  },
};

const deepLearningModule = {
  selector: ".voiceradar-deep-learning",
  $container: null,
  init() {
    const isMobile = window.innerWidth < 769;
    this.$container = $(this.selector);

    const headerHeight = isMobile
      ? 0
      : $("#shopify-section-header-classic").height() +
        $("#shopify-section-header__icon-bar").height();

    if (isMobile) {
      gsap.timeline({
        scrollTrigger: {
          trigger: this.selector + " .text-container",
          start: `top 60%`,
          toggleClass: "active",
        },
      });
    } else {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: this.selector,
            start: `top ${headerHeight}`,
            pin: true,
          },
        })
        .to(this.selector + " .mask", { opacity: 0.5 })
        .to(this.selector + " .text-container", {
          opacity: 1,
          y: 0,
        });
    }
  },
};

const immersiveAcousticsModule = {
  selector: ".voiceradar-immersive-acoustics",
  $container: null,
  init() {
    const isMobile = window.innerWidth < 769;
    this.$container = $(this.selector);

    const headerHeight =
      $("#shopify-section-header-classic").height() +
      $("#shopify-section-header__icon-bar").height();

    gsap.timeline({
      scrollTrigger: {
        trigger: this.selector + " .section-1 .voiceradar-section-header",
        start: `top 70%`,
        end: "+=300%",
        toggleClass: "active",
      },
    });

    gsap.timeline({
      scrollTrigger: {
        trigger: this.selector + " .section-1 .noise-samples-wrapper",
        start: `top 70%`,
        end: "+=300%",
        toggleClass: "active",
      },
    });

    const chipSize = isMobile
      ? {
          width: (224 / 750) * window.innerWidth,
          height: (224 / 750) * window.innerWidth,
          top: (148 / 750) * window.innerWidth * -1,
        }
      : {
          width: (330 / 1920) * window.innerWidth,
          height: (330 / 1920) * window.innerWidth,
          top: (50 / 1920) * window.innerWidth,
        };

    gsap
      .timeline({
        scrollTrigger: {
          trigger: this.selector + " .animation-section",
          start: `top top+=${headerHeight + 50}`,
          pin: true,
          end: "+=250%",
          toggleClass: "animation-section-fixed",
        },
      })
      .to(this.selector + " .animation-delay-mark", {
        y: 300,
      })
      .to(
        this.selector + " .section-1 .noise-samples-wrapper",
        {
          opacity: 0,
        },
        "scale"
      )
      .to(
        this.selector + " .section-1 .voiceradar-section-header",
        {
          opacity: 0,
        },
        "scale"
      )
      .to(this.selector + " .section-1 .display-image", chipSize, "scale")
      .to(
        this.selector + " .section-1 .display-image",
        {
          opacity: 0,
        },
        "chip-show"
      )
      .to(
        this.selector,
        {
          background: "#09101E",
        },
        "chip-show"
      )
      .to(
        this.selector + " .section-1 .chip-image",
        {
          opacity: 1,
        },
        "chip-show"
      )
      .to(
        this.selector + " .section-1 .chip-image",
        {
          right: isMobile
            ? (148 / 750) * window.innerWidth
            : (366 / 1920) * window.innerWidth,
        },
        "chip-move"
      )
      .to(
        this.selector + " .section-1 .chip-bg",
        {
          opacity: 1,
          delay: 0.1,
        },
        "chip-move"
      )
      .to(
        this.selector + " .section-2 .voiceradar-section-header .title",
        {
          opacity: 1,
          y: 0,
        },
        "chip-move"
      )
      .to(
        this.selector + " .section-2 .voiceradar-section-header .subtitle",
        {
          opacity: 1,
          y: 0,
        },
        "chip-move"
      )
      .to(
        this.selector,
        {
          background: "#000",
        },
        "chip-move"
      );

    gsap.timeline({
      scrollTrigger: {
        trigger: this.selector + " .section-3 .voiceradar-section-header",
        start: `top 70%`,
        toggleClass: "active",
      },
    });
    gsap.timeline({
      scrollTrigger: {
        trigger: this.selector + " .section-4 .voiceradar-section-header",
        start: `top 70%`,
        toggleClass: "active",
      },
    });
  },
};

const timelineModule = {
  selector: ".voiceradar-timeline",
  $container: null,
  init() {
    const isMobile = window.innerWidth < 769;
    this.$container = $(this.selector);

    gsap.timeline({
      scrollTrigger: {
        trigger: this.selector + " .voiceradar-section-header",
        start: `top 70%`,
        toggleClass: "active",
      },
    });

    gsap.timeline({
      scrollTrigger: {
        trigger: this.selector,
        start: `top 60%`,
        onEnter: () => {
          this.$container.addClass("active");
          if (!isMobile) {
            this.$container.find(".item-1").addClass("active");
            this.$container.find(".item-2").addClass("active");
            this.$container.find(".item-3").addClass("active");
          }
        },
      },
    });

    if (isMobile) {
      [
        this.selector + " .item-1",
        this.selector + " .item-2",
        this.selector + " .item-3",
      ].forEach((selector) => {
        gsap.timeline({
          scrollTrigger: {
            trigger: selector,
            start: `top 70%`,
            toggleClass: "active",
          },
        });
      });
    }
  },
};

$(document).ready(function () {
  // 订阅第一屏
  // notifyModule.init();

  // productModule.init();
  // banner
  bannerModule1.init();
  bannerModule2.init();

  // bannerModule.init();

  // noise cancellaction
  noiseCancellactionModule.init();

  // deep learning
  deepLearningModule.init();

  // immersive acoustics
  immersiveAcousticsModule.init();

  // time line
  timelineModule.init();

  window.addEventListener("resize", function () {
    ScrollTrigger.refresh();
  });

  $(".voiceradar-notify .submit-button").click(function () {
    // 提交订阅
    const email = $(".voiceradar-notify #userEmail").val().trim();
    const emailReg =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!email.match(emailReg)) {
      // 邮箱格式不正确：
      const emailError = $(this).data("email_error");
      $(".voiceradar-notify .error-box").text(emailError);
      return;
    }
    if (!$(".policy-checkbox").prop("checked")) {
      // 未同意policy
      const policyError = $(this).data("police_error");
      $(".voiceradar-notify .error-box").text(policyError);
      return;
    }
    // 订阅接口：
    $(this).addClass("submit-button-disabled");
    const dealsType = $(this).data("deals_type");
    const params = {
      email: email.toLowerCase(),
      genre: dealsType || "",
      shopify_domain: Shopify.shop,
      single_brand_subscribe: true,
    };
    Shopify.contentCreator.pastApi.subscribe_activities_emails({
      params,
      fn: (body) => {
        // 订阅成功
        $(this).removeClass("submit-button-disabled");
        const successTitle = $(this).data("success_title");
        const successDesc = $(this).data("success_desc");
        Shopify.contentCreator.activities.openSuccessBox(
          `<div>
            <div class="title" style="text-align: center;">${successTitle}</div>
            <div style="text-align: left;">${successDesc}</div>
          </div>
          `
        );
        $("#myModal #modal_con").css({ "text-align": "center" });
        $("#myModal #modal_con img").css({ width: "40px" });
        dataLayer.push({
          event: "uaEvent",
          eventCategory: "subscribe",
          eventAction: dealsType,
          eventLabel: "masterbanner",
        });
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: "ga4Event",
          event_name: "subscribe",
          event_parameters: {
            page_group: dealsType,
            position: "masterbanner",
          },
        });
        fbq("track", "CompleteRegistration");
      },
      error: (err) => {
        $(".voiceradar-notify .error-box").text(err.statusText).show();
        $(this).removeClass("submit-button-disabled");
      },
    });
  });

  // add to cart:
  $(".voiceradar-product .add-item-to-cart").click(function () {
    var id = $(this).data("variant_id");
    var variants = [
      {
        id,
        quantity: 1,
      },
    ];
    Shopify.theme.addItemsToCart(variants, {
      onError: (err) =>
        $.dialog({ title: err.message, content: err.description, type: "red" }),
    });
  });

  // ----------视频音频页的事件都在这儿了------
  // tab切换
  $(".voiceradar-noise-cancellation .tab-list").on("click", function () {
    const idx = $(this).index();
    $(this).addClass("tab-active").siblings().removeClass("tab-active");
    $(this)
      .parents(".video-list-container")
      .find(".video-item")
      .eq(idx)
      .addClass("tab-active")
      .siblings(".video-item")
      .removeClass("tab-active");
    // 暂停所有audio video：
    $(".voiceradar-noise-cancellation .video-item video").each(function () {
      $(this)[0].currentTime = 0;
      $(this)[0].pause();
      $(this).siblings(".btn-video-play").show();
    });
    $(".voiceradar-noise-cancellation .video-item audio").each(function () {
      $(this)[0].currentTime = 0;
      $(this)[0].pause();
      $(this).parents(".right-container").removeClass("playing");
      $(this).parents(".left-container").removeClass("playing");
    });
    noiseCancellactionModule.init();
  });

  // 播放按钮点击事件left：
  $(
    ".voiceradar-noise-cancellation .control-container .left-container .icon-container"
  ).on("click", function () {
    const $button = $(this);
    const $parent = $button.parents(".video-item");
    $parent.find(".slide-video-left").show();
    $parent.find(".slide-video-right").hide();
    const $controlContainer = $button.parents(
      ".control-container .left-container"
    );
    const $siblingControl = $button
      .parents(".control-container")
      .find(".right-container");
    const $video = $parent.find(".slide-video-left");
    const $audio = $parent.find(".audio-left");

    const $siblingVideo = $parent.find(".slide-video-right");
    const $siblingAudio = $parent.find(".audio-right");

    if ($video[0].paused) {
      $video[0].play();
      $audio[0].play();
      $siblingVideo[0].pause();
      $siblingAudio[0].pause();
      $video.siblings(".btn-video-play").hide();
      $controlContainer.addClass("playing");
      $siblingControl.removeClass("playing");
    } else {
      $video[0].pause();
      $audio[0].pause();
      $siblingVideo[0].pause();
      $siblingAudio[0].pause();
      $video.siblings(".btn-video-play").show();
      $controlContainer.removeClass("playing");
      $siblingControl.removeClass("playing");
    }
  });

  // 播放按钮点击事件right：
  $(
    ".voiceradar-noise-cancellation .control-container .right-container .icon-container"
  ).on("click", function () {
    const $button = $(this);
    const $parent = $button.parents(".video-item");
    $parent.find(".slide-video-right").show();
    $parent.find(".slide-video-left").hide();
    const $controlContainer = $button.parents(
      ".control-container .right-container"
    );
    const $siblingControl = $button
      .parents(".control-container")
      .find(".left-container");
    const $video = $parent.find(".slide-video-right");
    const $audio = $parent.find(".audio-right");

    const $siblingVideo = $parent.find(".slide-video-left");
    const $siblingAudio = $parent.find(".audio-left");
    // $controlContainer.toggleClass("playing");
    if ($video[0].paused) {
      $siblingVideo[0].pause();
      $siblingAudio[0].pause();
      $siblingControl.removeClass("playing");
      $video[0].play();
      $audio[0].play();
      $video.siblings(".btn-video-play").hide();
      $controlContainer.addClass("playing");
    } else {
      $video[0].pause();
      $audio[0].pause();
      $siblingControl.removeClass("playing");
      $siblingVideo[0].pause();
      $siblingAudio[0].pause();
      $video.siblings(".btn-video-play").show();
      $controlContainer.removeClass("playing");
    }
  });

  // 视频点击left
  $(".voiceradar-noise-cancellation .slide-video-left")
    .on("click", function () {
      const $video = $(this);
      const $parent = $video.parents(".video-item");
      const $audio = $parent.find(".audio-left");

      const videoElement = $(this)[0];
      if (videoElement.paused) {
        videoElement.play();
        $audio[0].play();
        $video.siblings(".btn-video-play").hide();
        $parent.find(".left-container").addClass("playing"); // play按钮
      } else {
        $video.siblings(".btn-video-play").show();
        $parent.find(".left-container").removeClass("playing"); // play按钮
        videoElement.pause();
        $audio[0].pause();
        videoElement.currentTime = 0;
        $audio[0].currentTime = 0;
      }
    })
    .on("pause", function () {
      // $(this)
      //   .parents(".video-item")
      //   .find(".control-container")
      //   .removeClass("playing");
    });

  // 视频点击right
  $(".voiceradar-noise-cancellation .slide-video-right")
    .on("click", function () {
      const $video = $(this);
      const $parent = $video.parents(".video-item");
      const $audio = $parent.find(".audio-right");

      const videoElement = $(this)[0];
      if (videoElement.paused) {
        videoElement.play();
        $audio[0].play();
        $video.siblings(".btn-video-play").hide();
        $parent.find(".right-container").addClass("playing"); // play按钮
      } else {
        $video.siblings(".btn-video-play").show();
        $parent.find(".right-container").removeClass("playing"); // play按钮
        videoElement.pause();
        $audio[0].pause();
        videoElement.currentTime = 0;
        $audio[0].currentTime = 0;
      }
    })
    .on("pause", function () {
      // $(this)
      //   .parents(".video-item")
      //   .find(".right-container")
      //   .removeClass("playing");
    });

  // 进度条点击left：
  $(
    ".voiceradar-noise-cancellation .control-container .left-container .progress-img"
  ).on("click", function (event) {
    const $parentContainer = $(this).parents(".video-item");
    const $siblingVideo = $parentContainer.find(".slide-video-right");
    const $siblingAudio = $parentContainer.find(".audio-right");
    $siblingVideo[0].pause(); // 暂停隔壁的视频
    $siblingAudio[0].pause(); // 暂停隔壁的音频
    $parentContainer.find(".slide-video-right").hide();
    $parentContainer.find(".slide-video-left").show();

    const $videoContainer = $parentContainer
      .find(".slide-video-container")
      .find(".slide-video-left");
    const $audioContainer = $parentContainer.find(".audio-left")[0];
    const progressBarWidth = $(this).width();
    const clickPosition = event.pageX - $(this).offset().left;
    const progressPercentage = clickPosition / progressBarWidth;
    const targetVideoTime = progressPercentage * $videoContainer[0].duration;
    const targetAudioTime = progressPercentage * $audioContainer.duration;
    $videoContainer[0].currentTime = targetVideoTime;
    $audioContainer.currentTime = targetAudioTime; // 音频
    $videoContainer[0].play();
    $audioContainer.play();
    $videoContainer.siblings(".btn-video-play").hide(); // 隐藏视频上的play按钮
    $parentContainer.find(".left-container").addClass("playing"); // 左边的play按钮
    $parentContainer.find(".right-container").removeClass("playing"); // 左边的play按钮
  });

  // 进度条点击right：
  $(
    ".voiceradar-noise-cancellation .control-container .right-container .progress-img"
  ).on("click", function (event) {
    const $parentContainer = $(this).parents(".video-item");
    const $siblingVideo = $parentContainer.find(".slide-video-left");
    const $siblingAudio = $parentContainer.find(".audio-left");
    $siblingVideo[0].pause(); // 暂停隔壁的视频
    $siblingAudio[0].pause(); // 暂停隔壁的音频
    $parentContainer.find(".slide-video-left").hide();
    $parentContainer.find(".slide-video-right").show();

    const $videoContainer = $parentContainer
      .find(".slide-video-container")
      .find(".slide-video-right");
    const $audioContainer = $parentContainer.find(".audio-right")[0];
    const progressBarWidth = $(this).width();
    const clickPosition = event.pageX - $(this).offset().left;
    const progressPercentage = clickPosition / progressBarWidth;
    const targetVideoTime = progressPercentage * $videoContainer[0].duration;
    const targetAudioTime = progressPercentage * $audioContainer.duration;
    $videoContainer[0].currentTime = targetVideoTime;
    $audioContainer.currentTime = targetAudioTime; // 音频
    $videoContainer[0].play();
    $audioContainer.play();
    $videoContainer.siblings(".btn-video-play").hide();
    $parentContainer.find(".right-container").addClass("playing");
    $parentContainer.find(".left-container").removeClass("playing"); // 左边的play按钮
  });

  // 音频update时更新进度条
  $(".voiceradar-noise-cancellation .audio-left")
    .on("timeupdate", function () {
      const currentTime = $(this)[0].currentTime;
      const videoDuration = $(this)[0].duration;

      const $controlContainer = $(this)
        .parents(".video-item")
        .find(".left-container");
      const $progressContainer = $controlContainer.find(".progress-img");
      const $playIcon = $controlContainer.find(".play-icon");
      const progressPercentage = currentTime / videoDuration;
      const progressBarWidth = $progressContainer.width();
      const progressPosition = progressPercentage * progressBarWidth;
      $playIcon.css({ left: `${progressPosition}px` });
    })
    .on("ended", function () {
      // 处理播放完毕的逻辑
      const $videoContainer = $(this)
        .parents(".video-item")
        .find(".slide-video-left");
      const $controlContainer = $(this)
        .parents(".video-item")
        .find(".control-container .left-container");
      $videoContainer[0].pause();
      $videoContainer.siblings(".btn-video-play").show();
      $controlContainer.removeClass("playing");
    });
  //
  $(".voiceradar-noise-cancellation .audio-right")
    .on("timeupdate", function () {
      const currentTime = $(this)[0].currentTime;
      const videoDuration = $(this)[0].duration;

      const $controlContainer = $(this)
        .parents(".video-item")
        .find(".right-container");
      const $progressContainer = $controlContainer.find(".progress-img");
      const $playIcon = $controlContainer.find(".play-icon");
      const progressPercentage = currentTime / videoDuration;
      const progressBarWidth = $progressContainer.width();
      const progressPosition = progressPercentage * progressBarWidth;
      $playIcon.css({ left: `${progressPosition}px` });
    })
    .on("ended", function () {
      // 处理播放完毕的逻辑
      const $videoContainer = $(this)
        .parents(".video-item")
        .find(".slide-video-right");
      const $controlContainer = $(this)
        .parents(".video-item")
        .find(".control-container .right-container");
      $videoContainer[0].pause();
      $videoContainer.siblings(".btn-video-play").show();
      $controlContainer.removeClass("playing");
    });
});
